<div class="heading" [style]="containerStyle">
  <h3 class="title" [style]="titleStyle" [innerHTML]="title"></h3>
  <p class="subtitle" [style]="subtitleStyle" [innerHTML]="subtitle"></p>
</div>
